import webApi from './webApi'
import { ApiClient } from './ApiClient'
import { IGuardingActivitiesData } from '../types/GuardingActivity/IGuardingActivityType'

const GetGuardingActivities = async (
  apiClient: ApiClient,
  page: number,
  storeCode: string
): Promise<IGuardingActivitiesData> => {
  const response = await webApi.get<IGuardingActivitiesData>(apiClient, {
    url: `/api/guarding`,
    params: { pageNumber: page, storeCode: storeCode }
  })
  return response
}

const guardingApi = {
  GetGuardingActivities
}

export default guardingApi